/* global angular */

'use strict';

var dates = require('util/dates');
const $ = require('jquery');
// const angular = require('angular');

var isEqual = require('lodash/isEqual');
// var maxBy = require('lodash/maxBy');
// var minBy = require('lodash/minBy');
var sortBy = require('lodash/sortBy');
// var filter = require('lodash/filter');
var uniqBy = require('lodash/uniqBy');
var moment = require('moment');
const cookies = require('js-cookie');

const cookieSettings = {
    expires: 30, // number of days cookie will be valid for
    path: '/',
    domain: '.' + window.location.hostname.split('.').slice(1).join('.'),
};


module.exports = ['$q', '$scope', '$timeout', '$attrs', 'plannerService', 'FacetService', 'appConfig', '$window', '$location', function ($q, $scope, $timeout, $attrs, plannerService, FacetService, appConfig, $window, $location) {
    var vm = this;

    var listConfigJSON = document.getElementById('json-EventListConfig');
    var listConfig = false;

    try {
        listConfig = JSON.parse(listConfigJSON.textContent);
    } catch (e) {} // eslint-disable-line no-empty

    var allResults = [];
    var updating = false;

    let maxTicketPrice = 0;

    vm.loading = true;
    vm.totalCount = 0;
    vm.results = [];
    vm.filters = null;
    vm.paginatedresults = [];

    $scope.child = {} //declare it in parent controller (scope)

    vm.showOptions = undefined;
    vm.selectedShow = 0;
    vm.selectedMonth = 'any';
    vm.selectedPriceRange = {
        min: 0,
        max: 150
    };

    vm.promoCode = null;
    vm.promoMsg = null;
    vm.promoCodeSet = false;
    vm.promoCodeChecking = false;
    vm.promoCodeFilter = false;
    vm.is_filtered = false;
    vm.promocodeInvalidMessage = '';


    vm.currentPage = 0;
    vm.resultsPerPage = 30;
    vm.pages = [];
    vm.paginationEllipses = {
        left: false,
        right: false,
    };

    let url = $location.search();

    vm.updateDates = dateRange => {
        vm.date_filter.range = dateRange;
        vm.currentPage = 0;
    }

    vm.keyword = '';
    vm.date_filter = {
        open: false,
        toggle: true,
        canClear: false,
        range : {
            start: null,
            end: null,
        },
        startSelected: dates.moment().format('MMM D, YYYY'),
        endSelected: dates.moment().format('MMM D, YYYY'),
        hasRange: false,
        startCalendarFocus: false,
        endCalendarFocus: false
    };
    vm.firstEvent = null;
    vm.lastEvent = null;

    var productionNo = undefined;

    vm.init = function () {
        if ('prodSeasonNo' in $attrs) {
            productionNo = parseInt($attrs.prodSeasonNo, 10);
        }

        vm.event_view = $attrs.eventView;

        plannerService.getPerformances().then(function (response) {
            let productions = uniqBy(response, 'prod_season_no');
            if (productionNo) {
                productions = productions.filter(production => production.prod_season_no === productionNo);
            }

            // Keep track of original data
            allResults = sortBy(response, function (item) {
                return item.start_date_moment;
            });

            if (productionNo) {
                allResults = allResults.filter(production => {
                    return production.prod_season_no === productionNo;
                });
            }

            allResults.forEach(perf => {
                perf.badge_classes = [];

                if (perf.flag) {
                    perf.badge_classes.push(`badge--flag-${perf.flag.replace(/\s/g, '-').toLowerCase()}`);
                }
            });

            $scope.slider = {
                minValue: 0,
                maxValue: 150,
                options: {
                    floor: 0,
                    ceil: 150,
                    step: 10,
                    hideLimitLabels: true,
                    hidePointerLabels: true
                },
            }

            for (let index = 0; index < productions.length; index++) {
                const production = productions[index];
                if (maxTicketPrice < production.max_price) {
                 maxTicketPrice = production.max_price;
                }
             }

             $scope.$on('slideEnded', function() {

                // forcing update after slider change to remove the laggy behaviour
                $scope.$apply(()=>{
                    vm.selectedPriceRange.min = $scope.slider.minValue;
                    vm.selectedPriceRange.max = $scope.slider.maxValue;
                })
            });

            vm.refreshSlider();


            $scope.applyPromoCode = function() {
            vm.promoCodeChecking = true;
            vm.promocodeInvalidMessage = '';

            let check = plannerService.checkPromoCode(vm.promoCode);

                check.then(response => {
                    let data = {
                        mos: response.data.mos,
                        source_no: response.data.source_no,
                        promo_code: response.data.promo_code,
                        promo_text: response.data.text1,
                    };

                    cookies.set('mos', data, cookieSettings);
                    // eslint-disable-next-line no-unused-vars
                    plannerService.addPromoCode(response.data.promo_code).then(response => {
                        vm.promoCodeChecking = false;

                        if(window.history){
                            // eslint-disable-next-line compat/compat
                            window.history.scrollRestoration = "manual"
                        }

                        $(window).on('beforeunload', function(){
                            $(window).scrollTop(0);
                        });

                        $window.location.reload();
                    });
                }).catch(e => {
                    console.warn(e);
                    vm.promocodeInvalidMessage = 'The promotional code you entered is not valid';
                    console.warn('promo code invalid, or check failed!');
                    vm.promoCodeChecking = false;
                });

                vm.init();

            }

            $scope.removePromoCode = function() {
                plannerService.removePromoCode().then(response => {
                    if (response.data.status === 'ok') {
                        cookies.set('mos', {}, cookieSettings);
                        $window.location.reload();
                    } else if (response.data.message) {
                        alert(response.data.message);
                    }
                });
            }

            try {
                const mos_data = cookies.get('mos');

                if (mos_data) {
                    vm.mos_data = JSON.parse(decodeURIComponent(decodeURIComponent(mos_data)));

                    if (vm.mos_data.promo_code) {
                        vm.promoMsg = vm.mos_data.promo_text.replace(/\+/g, ' ');
                        vm.promoCode = vm.mos_data.promo_code;
                        vm.promoCodeSet = true;
                    }
                }
            } catch (e) {
                console.warn(e)
            }

            vm.showOptions = [
                {
                    prodSeasonNo: 0,
                    title: 'Any Show',
                    value: undefined
                }
            ];

            for (let index = 0; index < productions.length; index++) {
                vm.showOptions.push({
                    prodSeasonNo: productions[index].prod_season_no,
                    title: productions[index].title,
                    value: productions[index].title
                })
            }

            if (productionNo) {
                response = response.filter(production=>{
                    return production.prod_season_no === productionNo;
                });
            }
            // Update view
            updateView(response);

            // Get a watcher going on keyword input & filters
            $scope.$watch(function () {
                return [vm.keyword, vm.filters, vm.date_filter.range, vm.selectedPriceRange, vm.promoCodeFilter, vm.selectedShow];
            }, processChanges, true);

            // Filter by location (potentially)
            var locationFacets = plannerService.locationFacets(vm.filters, true);


            if(url.production){
                vm.selectedShow = parseInt(url.production, 10);
            }

            if (locationFacets || url.production) {
                vm.keyword = locationFacets.keyword;
                vm.filters = locationFacets.filters;
                vm.date_filter.range = locationFacets.range;
                applyFiltering(locationFacets.keyword, locationFacets.filters, locationFacets.range, vm.selectedPriceRange, vm.promoCodeFilter, vm.selectedShow, false);
            } else {
                updateView(response);
            }
        }, function () {
            vm.errorLoading = true;
        }).finally(function () {
            vm.loading = false;


            $(document).on('click', '.js-type-info', function (e) {
                $.magnificPopup.open({
                    items: {
                        src: e.currentTarget.getAttribute('href'),
                        type: 'inline',
                    }
                });
            });

            $timeout(()=>{
                let calendar = document.querySelector('.calendar__container');
                const dp = $.datepicker._getInst(calendar);
                var start = (vm.date_filter.range.start) ? moment(vm.date_filter.range.start.format('YYYY-MM-DD')) : null;
                var end = (vm.date_filter.range.end) ? moment(vm.date_filter.range.end.format('YYYY-MM-DD')) : null;
                dp.settings.selectedRange(start, end);
            });

        });
    };

    vm.clearFilters = function () {
        let filters = vm.filters.map(filter=>{
            let filter_facets = filter.facets.map(facet =>{
                facet.checked = false;
                return facet;
            });
            filter.facets = filter_facets;
            return filter;
        });
        vm.filters = filters;
    }

    vm.refreshSlider = function() {
        $timeout(function() {
          $scope.$broadcast('rzSliderForceRender')
        })
      }

    vm.increment = function () {
        vm.ticketCount++;
    }

    vm.decrement = function () {
        if (vm.ticketCount === 0) {
            return;
        }
        vm.ticketCount--;
    }

    vm.togglePromoCodeFilter = function(){
        vm.promoCodeFilter = !vm.promoCodeFilter;
    }

    vm.toggleDateFilter = function () {
        if (!vm.date_filter.toggle || vm.date_filter.canClear) {
            return false;
        }
        vm.date_filter.open = !vm.date_filter.open;
    };

    vm.clearDateFilter = function ($event) {
        vm.date_filter.range = {
            start: null,
            end: null
        };

        vm.date_filter.canClear = false;
        $event.stopPropagation();
    };

    vm.toggleFilter = function (group) {
        // Tell angular to NOT run filters
        updating = true;

        if (!group.toggle || group.canClear) {
            updating = false;
            return false;
        }

        group.open = !group.open;

        $timeout(function () {
            updating = false;
        });
    };

    function processChanges(newVal, oldVal) {

        // Skip when loading, updating, or same values

        if( newVal[5] !== oldVal[5]) { // reset pagination if the production changes
            vm.currentPage = 0;
        }

        if (vm.loading || updating || isEqual(newVal, oldVal)) {
            return false;
        }

        var keyword = newVal[0];
        var filters = newVal[1];
        var range = newVal[2];
        var price = newVal[3];
        var promoCodeFilter = newVal[4];
        var selectedShow = newVal[5];


        applyFiltering(keyword, filters, range, price, promoCodeFilter, selectedShow, true);
    }


    function applyFiltering(keyword, filters, range, price, promoCodeFilter, selectedShow, updateLocation) {

        // Grab a list of applied facets
        filters = FacetService.updateFacets(filters);

        // Now, apply filters
        var result = FacetService.applyFilters({
            items: allResults,
            selectedShow: selectedShow,
            keyword: keyword,
            filters: filters,
            range: range,
            price: vm.selectedPriceRange
        });

        if (updateLocation) {

            plannerService.updateLocation({
                keyword: keyword,
                facets: result.facets,
                range: range
            });
        }


        if(vm.promoCodeSet && vm.promoCodeFilter) {
            result.items = result.items.filter(perf => perf.has_promo);
        }

        // Update view :3
        updateView(result.items, result.facets);
    }

    function populatePages() {

        if (vm.results.length < 1){
            vm.currentPage = 0;
            vm.paginatedresults = [];

            return false;
        }
        let pages = [];
        for(let i = 0, n = 0; i<vm.results.length; n++, i += vm.resultsPerPage) {
            pages.push({
                index: n,
                pageNo: n + 1,
                start: i,
                count: vm.resultsPerPage,
                visible: false,
                current: false,
            });
        }

        let surroundingPagesToShow = 3;

        for(
            let i = Math.max(0, vm.currentPage - surroundingPagesToShow + 1);
            i < Math.min(pages.length, vm.currentPage + surroundingPagesToShow);
            i++
        ) {
                let page = pages[i];
                page.visible = true;
        }

        vm.paginationEllipses.left = (vm.currentPage - surroundingPagesToShow + 1) > 0 ? true : false;
        vm.paginationEllipses.right = (vm.currentPage + surroundingPagesToShow) < pages.length ? true : false;

        let currentPage = pages[vm.currentPage];

        currentPage.current = true;
        vm.pages = pages;

        setPaginatedResults();
    }

    function setPaginatedResults(){
        var results = vm.results.slice(vm.pages[vm.currentPage].start, vm.pages[vm.currentPage].start + vm.resultsPerPage);
        vm.paginatedresults = results;

    }

    vm.goToPage = function(page) {
        // eslint-disable-next-line compat/compat
        var url = new URL(window.location);
        url.searchParams.set('page', page.index + 1);

        window.history.pushState({page: page.index + 1}, null, url.toString());

        vm.currentPage = page.index;

        let pages = vm.pages.map(page=>{
            page.current = false;
            return page;
        });

        vm.pages = pages;

        let currentPage = vm.pages[vm.currentPage];
        currentPage.current = true;
        setPaginatedResults();


    }

    function updateView(items, facets) {

        // Keep track is updating to prevent watch firing
        updating = true;

        // Grab count before grouped
        vm.totalCount = items.length;

        // Grab filters (or generate)
        var filters = vm.filters || FacetService.generateFilters(items, listConfig);

        // Make sure something is there
        if (!facets) {
            // Grab a list of applied facets
            facets = [];
        }



        // Expose items
        var allItems = items;
        vm.results = allItems;

        // Generate filters!
        // This method updates the state of the filters and the current 'count' values
        // You need to pass in ALL results unless the promocode is set.
        vm.filters = FacetService.updateFilters({
            filters: filters,
            // The filters are based on ALL results
            items: (vm.promoCodeSet && vm.promoCodeFilter) ? allItems : allResults,
            selectedShow: vm.selectedShow,
            facets: facets,
            keyword: vm.keyword,
            range: vm.date_filter.range,
            price: vm.selectedPriceRange
        });

        vm.is_filtered = vm.filters.reduce((carry, filter)=>{

            let filterIsChecked = filter.facets.reduce((isChecked, facet)=>{
                if (facet.checked) {
                    isChecked = facet.checked;
                }
                return isChecked;
            }, false);

            if(filterIsChecked) {
                carry = filterIsChecked;
            }
            return carry;

        }, false);



        populatePages();

        // Reset updating flag
        $timeout(function () {
            updating = false;
        });
    }

    return vm;
}];



// WEBPACK FOOTER //
// ./widgets/controllers/ProductionListCtrl.js